import {Component} from '@angular/core';
import {ModalController} from '@ionic/angular';
import {from} from 'rxjs';
import {Device} from '@capacitor/device';
import {map} from 'rxjs/operators';
import {AndroidSettings, IOSSettings, NativeSettings} from 'capacitor-native-settings';

@Component({
  selector: 'app-activate-notifications-modal',
  templateUrl: './activate-notifications-modal.component.html',
  styleUrls: ['./activate-notifications-modal.component.scss'],
})
export class ActivateNotificationsModalComponent {
  devicePlatformInfo$ = from(Device.getInfo()).pipe(map(info => info.platform));

  constructor(private modalCtrl: ModalController) { }

  goToAppNotificationSettings() {
    this.devicePlatformInfo$.subscribe(platform => {
      if (platform !== 'web') {
        NativeSettings.open({
          optionAndroid: AndroidSettings.AppNotification,
          optionIOS: IOSSettings.App
        }).then(() => {
          this.dismiss(true);
        });
      }
    });
  }

  dismiss(validate: boolean = false) {
    this.modalCtrl.dismiss({validate});
  }

}
